import { useNavigate } from "react-router-dom";
import StudentApplicantNavData from "./StudentApplicantNavData";

const ApplicantNav = () => {
  const navigate = useNavigate();

  return (
    <ul className="space-y-1"> {/* Reduced vertical spacing */}
      {StudentApplicantNavData?.map(({ Icon, ...i }, index) => (
        <li key={i.id}>
          <button
            onClick={() => navigate(i.to)}
            className="flex items-center w-full px-4 py-2 text-gray-700 rounded-lg hover:bg-gray-100"
          >
            <img src={Icon} alt={i.label} className="w-5 h-5 mr-1" /> {/* Reduced size and margin */}
            <span className="text-sm font-medium">{i.label}</span>
          </button>
        </li>
      ))}
    </ul>
  );
  
};

export default ApplicantNav;